import { Compact, CompactRow, FieldLabel, FieldSelect, FieldSelectMulti } from '@newageerp/v3.bundles.form-bundle'
import { useURequest } from '@newageerp/v3.bundles.hooks-bundle';
import React, { useEffect } from 'react'

type Props = {
    funnels: string[],
    setFunnels: (v: string[]) => void,
}

export default function FunnelFilter(props: Props) {
    const t = (e: string) => e;
    
    const { funnels, setFunnels } = props;

    const [doReq, reqData] = useURequest<string>("/app/plugins/Reports/ReportsFilter/slugs");

    useEffect(() => {
        doReq({})
    }, []);

    return (
        <Compact>
            <CompactRow
                label={<FieldLabel>{t('Funnel')}</FieldLabel>}
                control={
                    <FieldSelectMulti
                        value={funnels}
                        onChange={setFunnels}
                        options={[
                            ...reqData.data.data.map(s => {
                                return (
                                    {
                                        label: s,
                                        value: s,
                                    }
                                )
                            }),
                        ]}
                        allowSelectAll={true}
                        asString={true}
                    />
                }
            />
        </Compact>
    )
}
